<template>
    <modal @close="$emit('close')">
        <template slot="header">
            Campaign creator -
            <button type="button" class="btn btn-primary" :disabled="step == 0" @click="step--">Back</button>
            <button type="button" class="btn btn-primary" :disabled="!canNext" @click="setNextStep">Next</button>
            <button type="button" class="btn btn-primary" :disabled="step !== 1" @click="save()">Save</button>
            <button class="btn btn-link" @click="$emit('close')">Cancel</button>
        </template>
        <div class="alert alert-danger" v-if="err">{{ err }}</div>
        <div class="alert alert-success" v-if="success">{{ success }}</div>
        <div class="row" v-if="step === 0">
            <div class="col-4">
                <div class="form-group row">
                    <div class="col-lg-12">
                        <label class="col-form-label col-lg-12">List of domain,template
                            (foobar.com,template_name)</label>
                        <ace-editor :editor-id="'step1_domains'" @change-content="contentChangedStep1Domains"
                            :content="step1_domains || ''" lang="text" theme="monokai"
                            v-bind:style="{ 'width': '100%', height: '300px' }"></ace-editor>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group row">
                    <div class="col-lg-12">
                        <label class="col-form-label col-lg-12">List of contact lists by name (one per line)</label>
                        <ace-editor :editor-id="'step1_lists'" @change-content="contentChangedStep1Lists"
                            :content="step1_lists || ''" lang="text" theme="monokai"
                            v-bind:style="{ 'width': '100%', height: '300px' }"></ace-editor>
                    </div>
                </div>
            </div>

            <div class="col-6">
                <!-- <div class="form-group row">
                    <label class="col-form-label col-lg-3">Number of campaigns for each AWS account</label>
                    <div class="col-lg-6">
                        <input type="number" class="form-control" v-model="form_common.campaigns_per_domain">
                    </div>
                </div> -->
                <div class="form-group row">
                    <label class="col-form-label col-lg-3">Start time</label>
                    <div class="col-lg-6">
                        <input type="text" class="form-control" v-model="form.scheduled_at"
                            :placeholder="schedulePlaceholder | estTime">
                        <small>Use <strong>EST time</strong> (UTC-5)</small>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-form-label col-lg-3">Minutes between campaigns</label>
                    <div class="col-lg-6">
                        <input type="number" class="form-control" v-model="form_common.minutes_interval">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-form-label col-lg-3">Time interval in minutes between each round</label>
                    <div class="col-lg-6">
                        <input type="number" class="form-control" v-model="form_common.minutes_interval_per_round">
                    </div>
                </div>
            </div>

        </div>

        <div class="row" v-if="step === 1">
            <div class="form-group row">
                <label for="picker1" class="col-sm-3 control-label">
                    Automation:
                </label>
                <div class="col-lg-8" v-if="form.automation !== null">
                    <input type="number" class="form-control" v-model="form.automation.wait_seconds" />
                    <small>Number of seconds to wait before sending email (greater than 0)</small><br />

                    <input type="checkbox" name="sendon" value="true" id="send_on_click"
                        v-model="form.automation.send_on_click"> <label for="send_on_click">Send on click</label><br />
                    <input type="checkbox" name="sendon" value="true" id="send_on_open"
                        v-model="form.automation.send_on_open">
                    <label for="send_on_open">Send on open</label><br />

                    Template:
                    <div class="form-check form-check-inline">
                        <multiselect v-model="form.automation.template" tag-placeholder=""
                            @search-change="templateFindByName" :searchable="true" :loading="loadingTypeahead"
                            placeholder="Search for a template TAG" label="name" track-by="_id"
                            :options="templateList || []" :multiple="false"></multiselect>
                    </div>
                </div>
                <div style="margin-left:20px" class="col-lg-3">
                    <button v-if="form.automation == null" @click="fillAutomation" class="btn btn-sm btn-primary">Enable
                        automation</button>
                    <button v-else @click="form.automation = null" class="btn btn-sm btn-danger">Disable
                        automation</button>
                </div>
            </div>
            <div class="col-12">
                <h2>A list of campaigns to be created</h2>
                <div v-for="c, i in campaigns" style="border-bottom: 1px solid rgba(0,0,0,.2)">
                    <template v-if="(i == 0 || campaigns[i - 1].batch !== c.batch)">
                        <div style="margin-top:15px; font-size: 14px;">Round #{{ c.batch + 1 }}</div>
                    </template>
                    <strong>Name</strong>: {{ c.name }},
                    <strong>Start at</strong>: {{ c.start_at | estTime }},
                    <strong>Domain</strong>: {{ c.domain.domain }},
                    <strong>Mailer</strong>: {{ c.mailer.name }} ({{ c.mailer.provider }}: {{ c.mailer.status || "-"
                    }}),
                    <strong>Contact list</strong>: {{ c.contact_list.name }},
                    <strong>Template</strong>: {{ c.template.name }}
                    <template v-if="c.error">
                        <br /><strong>{{ c.error }}</strong>
                    </template>
                    <template v-if="c.success">
                        <br /><strong>Campaign created successfully</strong>
                    </template>
                    <template v-if="c.validated">
                        <br /><strong>Campaign validated</strong>
                    </template>
                </div>
            </div>

        </div>
        <div class="col-12">
            <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                <div class="alert alert-danger" v-if="err">{{ err }}</div>
                <div class="alert alert-success" v-if="success">{{ success }}</div>
                <div class="form-group row">
                    <label class="col-form-label col-lg-12">
                        <button type="button" class="btn btn-primary" :disabled="step == 0"
                            @click="step--">Back</button>
                        <button type="button" class="btn btn-primary" :disabled="!canNext"
                            @click="setNextStep">Next</button>
                        <button type="button" class="btn btn-primary" :disabled="step !== 1"
                            @click="save()">Save</button>
                        <button class="btn btn-link" @click="$emit('close')">Cancel</button>
                    </label>
                </div>
            </fieldset>
        </div>
    </modal>
</template>
<script>
import modal from '../common/Modal.vue'
import aceEditor from '../common/Ace.js'
import datetime from 'vuejs-datetimepicker';
import moment from 'moment'

let dbtm

export default {
    components: { modal, aceEditor, datetime },
    props: {
        id: null,
    },
    data() {
        return {
            step: 0,
            show_help: false,
            fullscreen: false,
            err: null,
            success: null,
            loading: false,

            mailer_account: [],
            list: [],
            templateList: [],
            domain: [],
            name_templates: [],
            loadingTypeahead: false,
            campaign_tags: [],
            contact_list_tags: [],

            campaigns: [],

            step1_lists: '',
            step1_domains: '',

            form_common: {
                campaigns_per_domain: 0,
                minutes_interval: 0,
                minutes_interval_per_round: 0,
            },
            loadingTypeahead: false,
            templateList: [],

            round_size: 0,

            form: {
                send_limit: 0,
                scheduled_at: null,
                automation: null,
            },

        }
    },
    methods: {
        setNextStep: async function () {
            this.err = null
            this.loading = true
            try {
                if (this.step === 0) {
                    let res = await this.validate1Step()
                    this.generateStep2(res)
                }
                this.step++
            } catch (e) {
                console.log('error', e)
                this.err = e
            }
            this.loading = false
        },
        templateFindByName(query) {
            if (query === '') {
                return
            }
            this.templateList = []

            this.loadingTypeahead = true
            clearTimeout(dbtm)
            dbtm = setTimeout(() => {
                this.$api.getReq('template?query=' + query).then(res => {
                    this.loadingTypeahead = false
                    this.templateList = res.body.data
                })
            }, 500)
        },

        fillAutomation: function () {
            this.form.automation = {
                wait_seconds: 0,
                send_on_click: false,
                send_on_open: false,
                template: null
            }
        },
        generateStep2: function (res) {
            let { domains, templates, contact_lists } = res
            let campaigns = []

            function pad(num, size) {
                num = num.toString();
                while (num.length < size) num = "0" + num;
                return num;
            }

            let st = moment(this.form.scheduled_at + '-05:00', 'DD-MM-YY HH:mmZZ')

            this.round_size = contact_lists.length / domains.length
            let cli = 0

            let batches = []
            for (let i = 0; i < this.round_size; i++) {
                let firstSt = st.clone().toDate()
                domains.forEach((d, di) => {

                    let dt = st.clone()
                    let idx = i + di * this.round_size

                    // console.log(this.round_size, threshold, idx, di)
                    batches.push({
                        batch: i,
                        name: [d.domain, d.mailer_account.name, dt.format('DD MMMM YYYY'), "#" + pad(di + (i * this.round_size) + 1, 3)].join(" - "),
                        start_at: dt.toDate(),
                        domain: {
                            domain: d.domain,
                            _id: d._id
                        },
                        template: {
                            name: templates[di].name,
                            _id: templates[di]._id
                        },
                        error: '',
                        success: false,
                        mailer: d.mailer_account,
                        contact_list: {
                            name: contact_lists[idx].name,
                            _id: contact_lists[idx]._id,
                        }
                    })

                    st.add(this.form_common.minutes_interval, 'minutes').clone()
                })

                st = moment(firstSt).add(this.form_common.minutes_interval_per_round, 'minutes')

            }

            this.campaigns = batches

        },
        getFirstScheduledAt: function () {
            return moment().utcOffset(-5 * 60)
        },
        contentChangedStep1Domains(c) {
            this.step1_domains = c
        },
        contentChangedStep1Lists(c) {
            this.step1_lists = c
        },
        templateFind(query) {
            if (query === '') {
                return
            }
            this.templateList = []

            this.loadingTypeahead = true
            clearTimeout(dbtm)
            dbtm = setTimeout(() => {
                this.$api.getReq('template_tags?query=' + query).then(res => {
                    this.loadingTypeahead = false
                    this.templateList = res.body.data
                })
            }, 500)
        },
        parseStep1: function () {
            let domains = []
            let templates = []
            let contact_lists = this.step1_lists.split("\n").filter(l => l.length).map(row => row.trim())

            this.step1_domains.split("\n").filter(l => l.length).map(l => l.split(",")).forEach(el => {
                if (el.length !== 2) {
                    throw new Error("Invalid input")
                }
                domains.push(el[0].trim())
                templates.push(el[1].trim())
            })

            return { domains, templates, contact_lists }
        },
        async validate1Step() {
            let parsed = this.parseStep1()
            if (parsed.contact_lists.length % parsed.domains.length !== 0) {
                throw new Error(`Number of domains doesnt match number of contact lists, 
                expected number of contact lists to be multiplication of: ${parsed.domains.length}, (closest number: ${parsed.domains.length * Math.round(parsed.contact_lists.length / parsed.domains.length)})`)
            }

            return new Promise((resolve, reject) => {
                this.$api.postReq("verify", parsed).then(res => {

                    let msg = ''
                    if (res.data.result.missing_domains.length) {
                        msg += `Missing domains or not validated: ${res.data.result.missing_domains.join(', ')}. `
                    }
                    if (res.data.result.missing_templates.length) {
                        msg += `Missing templates: ${res.data.result.missing_templates.join(', ')}. `
                    }
                    if (res.data.result.missing_lists.length) {
                        msg += `Missing contact lists: ${res.data.result.missing_lists.join(', ')}. `
                    }

                    if (msg) {
                        reject(msg)
                    } else {
                        // we're ordering the results in the same way they were provided
                        let dictDomains = {}
                        let dictTemplates = {}
                        let dictLists = {}
                        res.data.result.domains.forEach(d => { dictDomains[d.domain] = d })
                        res.data.result.lists.forEach(d => { dictLists[d.name] = d })
                        res.data.result.templates.forEach(d => { dictTemplates[d.name] = d })
                        resolve({
                            domains: parsed.domains.map(d => dictDomains[d]),
                            templates: parsed.templates.map(d => dictTemplates[d]),
                            contact_lists: parsed.contact_lists.map(d => dictLists[d]),
                        })
                    }
                })
            })

        },
        async save(_, cb) {

            this.loading = true

            let anyErr = false

            for (let i = 0; i < this.campaigns.length; i++) {
                this.campaigns[i].error = null
                try {
                    await this._saveOne(this.campaigns[i], true)
                    this.campaigns[i].validated = true

                } catch (e) {
                    this.campaigns[i].error = e.message || e
                    this.campaign[i].validated = false
                    anyErr = true
                }
            }

            if (anyErr) {
                return
            }

            for (let i = 0; i < this.campaigns.length; i++) {
                this.campaigns[i].error = null
                try {
                    await this._saveOne(this.campaigns[i], false)
                    await new Promise(resolve => setTimeout(resolve, 200))
                    this.campaigns[i].success = true

                } catch (e) {
                    this.campaigns[i].error = e.message || e
                    this.campaign[i].validated = false
                    anyErr = true
                }
            }

            this.loading = false

            if (!anyErr) {
                this.$emit('reload')
                this.$emit('close')
            }
        },
        async _saveOne(campaign, validate) {

            let automation = undefined
            if (this.form.automation) {
                automation = JSON.parse(JSON.stringify(this.form.automation))
                if (this.form.automation.template) {
                    automation.template = this.form.automation.template._id
                }
            }

            let f = {
                name: campaign.name,
                scheduled_at: campaign.start_at,
                list: campaign.contact_list._id,
                domain: campaign.domain._id,
                mailer_account: campaign.mailer._id,
                message_template_id: campaign.template._id,
                automation
            }

            return new Promise((resolve, reject) => {
                this.$api.postReq('campaign' + (validate && '?skip_saving=1' || ''), f).then(res => {
                    resolve()
                }).catch(res => {
                    reject(res.body.error)
                })
            })
        },
        async validate(_, cb) {
            this.loading = true

            // validate here

            this.loading = false

            return true
        },
    },
    watch: {
    },
    computed: {
        schedulePlaceholder() {
            return moment().add(4, 'hour')
        },
        canTestEmail() {

            if (this.id === null) {
                return false
            }

            if (this.testEmail.indexOf('@') <= 0) {
                return false
            }

            if (this.form.message_templates.length === 0) {
                if (!this.form.mailer_account || !this.form.domain) {
                    return false
                }
            } else {
                return true
            }

            return true
        },
        canNext() {
            switch (this.step) {
                case 0:
                    return this.form_common.minutes_interval > 0
                case 1:
                    return false
            }
        },
        step1Domains() {
            return this.step1_domains.split("\n").map(s => s.trim()).filter(s => s)
        },
        step1Lists() {
            return this.step1_lists.split("\n").map(s => s.trim()).filter(s => s)
        },
        step1Subjects() {
            return this.step1_subjects.split("\n").map(s => s.trim()).filter(s => s)
        },
        step1ErrorsForm() {
            let dc = this.step1Domains.length
            let lc = this.step1Lists.length
            let sc = this.step1Subjects.length

            // if (dc > 0 && (dc !== lc || dc !== sc || lc !== sc)) {
            //     return 'Fill the same number of rows in every column'
            // }
            return ''
        },
        step1Errors() {
            // if (this.step1ErrorsForm) {
            //     return this.step1ErrorsForm
            // }

            // if (this.verifiedLists && (this.verifiedLists.missing_domains || this.verifiedLists.missing_lists)) {
            //     let msg = ''
            //     if (this.verifiedLists.missing_domains.length) {
            //         msg += `Missing domains or not validated: ${this.verifiedLists.missing_domains.map(d => {
            //             return d + ` (line #${this.step1Domains.indexOf(d) + 1})`
            //         }).join(', ')} <br/>`
            //     }
            //     if (this.verifiedLists.missing_lists.length) {
            //         msg += `Missing contact lists: ${this.verifiedLists.missing_lists.map(d => {
            //             return d + `(#${this.step1Lists.indexOf(d) + 1})`
            //         }).join(', ')} <br/>`
            //     }
            //     return msg
            // }

            return ''
        }
    },
    mounted() {
        this.loading = 1

        if (document.location.href.indexOf('localhost') >= 0) {
            this.step1_lists = `list9
list8
list7
list6
list5
list4
list3
list2
list1
list10
list11
list12`
            this.step1_domains = `baz3.com,name3
baz1.com,name1
baz2.com,name2
baz4.com,name4`

            // this.form_common.name = 'ttesst' + new Date()
            // this.form_common.minutes_interval = 10
        }

        this.form.scheduled_at = this.$options.filters.estTime(this.getFirstScheduledAt().add(1, 'hours'))

        this.$api.getReq('campaign_create').then(res => {
            this.mailer_account = res.body.data.mailer_account
            this.name_templates = res.body.data.name_templates.map(n => {
                n.name = n._id
                return n
            })
            this.form.send_limit = res.body.data.default_throttle || 0
            this.campaign_tags = res.body.data.campaign_tags
            this.contact_list_tags = res.body.data.contact_list_tags
            this.loading--

        })

    }
}
</script>
<style>
.modal-full {
    height: 95% !important;
    top: 0;
    width: 99% !important;
}

.ifrfull {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 1000000 !important;
}

div.disabled {
    pointer-events: none;

    /* for "disabled" effect */
    opacity: 0.5;
    background: #CCC;
}
</style>


// WEBPACK FOOTER //
// src/components/modal/MultipleCampaignCreator2.vue